<template>
  <div class="animated revealUp">
    <div class="white-wrapper" style="zoom: 0.9">
      <div class="section-title">
        {{ $t("Maskewaari Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-4 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("To Date") }}
                </label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getMaskewaariReport()"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            v-if="MaskewaariRecords.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->
            <a
              target="_blank"
              @click="getMaskewaariReport('N', 'Y')"
              download
              title="Download as PDF"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>

            <a
              target="_blank"
              @click="getMaskewaariReport('Y', 'N')"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <div class="swc-report">
        <!-- Maskewaari Report -->
        <table class="swc-report-table w-50 mt-2" border="1">
          <tr class="bg-lightgrey font-weight-bold">
            <td class="text-left">Show Date</td>
            <td class="text-left">Event</td>
            <td class="text-left">Net Sum</td>
            <td class="text-left">Gross Sum</td>
            <td class="text-left">Gross Sales Return</td>
            <td class="text-left">New Gross Sales</td>
            <td class="text-left">New Net Sales</td>
            <td class="text-left">FDT</td>
            <td class="text-left">LDT</td>
            <td class="text-left">Taxable</td>
            <td class="text-left">VAT</td>
            <td class="text-left">Gross Amount</td>
            <td class="text-left">3D NET</td>
            <td class="text-left">3D VAT</td>
            <td class="text-left">3D GROSS</td>
          </tr>
          <template v-if="MaskewaariRecords.length > 0">
            <tr v-for="(singleRecord, index) in MaskewaariRecords" :key="index">
              <td class="text-left">{{ singleRecord.showDate }}</td>
              <td class="text-left">{{ singleRecord.event }}</td>
              <td class="text-right">
                {{
                  parseFloat(singleRecord.net_sum).toFixed(MIN_FRACTION_DIGITS)
                }}
              </td>
              <td class="text-right">
                {{
                  parseFloat(singleRecord.gross_sum).toFixed(
                    MIN_FRACTION_DIGITS
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  parseFloat(singleRecord.gross_sales_return).toFixed(
                    MIN_FRACTION_DIGITS
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  parseFloat(singleRecord.new_gross_sum).toFixed(
                    MIN_FRACTION_DIGITS
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  parseFloat(singleRecord.new_net_sum).toFixed(
                    MIN_FRACTION_DIGITS
                  )
                }}
              </td>
              <td class="text-right">
                {{ parseFloat(singleRecord.FDT).toFixed(MIN_FRACTION_DIGITS) }}
              </td>
              <td class="text-right">
                {{ parseFloat(singleRecord.LDT).toFixed(MIN_FRACTION_DIGITS) }}
              </td>
              <td class="text-right">
                {{
                  parseFloat(singleRecord.taxable).toFixed(MIN_FRACTION_DIGITS)
                }}
              </td>
              <td class="text-right">
                {{ parseFloat(singleRecord.VAT).toFixed(MIN_FRACTION_DIGITS) }}
              </td>
              <td class="text-right">
                {{
                  parseFloat(singleRecord.final_gross).toFixed(
                    MIN_FRACTION_DIGITS
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  parseFloat(singleRecord._3D_NET).toFixed(MIN_FRACTION_DIGITS)
                }}
              </td>
              <td class="text-right">
                {{
                  parseFloat(singleRecord._3D_VAT).toFixed(MIN_FRACTION_DIGITS)
                }}
              </td>
              <td class="text-right">
                {{
                  parseFloat(singleRecord._3D_GROSS).toFixed(
                    MIN_FRACTION_DIGITS
                  )
                }}
              </td>
            </tr>
            <tr class="bg-lightgrey font-weight-bold">
              <td class="text-left" colspan="2">Total</td>
              <td class="text-right">
                {{
                  currFormat(
                    MaskewaariRecords.reduce((acc, { net_sum }) => {
                      return acc + +parseFloat(net_sum || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    MaskewaariRecords.reduce((acc, { gross_sum }) => {
                      return acc + +parseFloat(gross_sum || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    MaskewaariRecords.reduce((acc, { gross_sales_return }) => {
                      return acc + +parseFloat(gross_sales_return || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    MaskewaariRecords.reduce((acc, { new_gross_sum }) => {
                      return acc + +parseFloat(new_gross_sum || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    MaskewaariRecords.reduce((acc, { new_net_sum }) => {
                      return acc + +parseFloat(new_net_sum || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    MaskewaariRecords.reduce((acc, { FDT }) => {
                      return acc + +parseFloat(FDT || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    MaskewaariRecords.reduce((acc, { LDT }) => {
                      return acc + +parseFloat(LDT || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    MaskewaariRecords.reduce((acc, { taxable }) => {
                      return acc + +parseFloat(taxable || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    MaskewaariRecords.reduce((acc, { VAT }) => {
                      return acc + +parseFloat(VAT || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    MaskewaariRecords.reduce((acc, { final_gross }) => {
                      return acc + +parseFloat(final_gross || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    MaskewaariRecords.reduce((acc, { _3D_NET }) => {
                      return acc + +parseFloat(_3D_NET || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    MaskewaariRecords.reduce((acc, { _3D_VAT }) => {
                      return acc + +parseFloat(_3D_VAT || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    MaskewaariRecords.reduce((acc, { _3D_GROSS }) => {
                      return acc + +parseFloat(_3D_GROSS || 0);
                    }, 0)
                  )
                }}
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="15">
                <NoRecords />
              </td>
            </tr>
          </template>
        </table>
        <!-- Maskewaari Report -->

        <!-- Product Sales Info -->
        <div class="section-title mt-4">Product Sales Info</div>
        <table class="swc-report-table w-50 mt-2" border="1">
          <tr class="bg-lightgrey font-weight-bold">
            <td class="text-left">Particulars</td>
            <td class="text-left">Taxable</td>
            <td class="text-left">VAT</td>
            <td class="text-left">Gross Amount</td>
          </tr>
          <template v-if="ProductInfoRecords.length > 0">
            <tr
              v-for="(singleRecord, index) in ProductInfoRecords"
              :key="index"
            >
              <td class="text-left">{{ singleRecord.particulars }}</td>
              <td class="text-right">
                {{
                  parseFloat(singleRecord.taxable).toFixed(MIN_FRACTION_DIGITS)
                }}
              </td>
              <td class="text-right">
                {{ parseFloat(singleRecord.VAT).toFixed(MIN_FRACTION_DIGITS) }}
              </td>
              <td class="text-right">
                {{
                  parseFloat(singleRecord.gross).toFixed(MIN_FRACTION_DIGITS)
                }}
              </td>
            </tr>
            <tr class="bg-lightgrey font-weight-bold">
              <td class="text-left">Total</td>
              <td class="text-right">
                {{
                  currFormat(
                    ProductInfoRecords.reduce((acc, { taxable }) => {
                      return acc + +parseFloat(taxable || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    ProductInfoRecords.reduce((acc, { VAT }) => {
                      return acc + +parseFloat(VAT || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    ProductInfoRecords.reduce((acc, { gross }) => {
                      return acc + +parseFloat(gross || 0);
                    }, 0)
                  )
                }}
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="4">
                <NoRecords />
              </td>
            </tr>
          </template>
        </table>
        <!-- Product Sales Info -->
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
        selectedCinemaAddress:"",
      },
      fromDate: new Date(),
      toDate: new Date(),
      MaskewaariRecords: [],
      ProductInfoRecords: [],
      excelFilePath: "",
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.getCinemaList(obj);
  },
  watch: {
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() {},
  methods: {
    moment,
    getCinemaList: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.dropDown.selectedCinemaAddress = event.cine_address;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getMaskewaariReport(isExcelDownload = "N", isPdf = "N") {
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      } else if (!this.toDate) {
        return this.$toasted.show("Select To Date");
      } else if (
        moment(moment(this.fromDate).format("YYYY-MM-DD")).isAfter(
          moment(this.toDate).format("YYYY-MM-DD")
        )
      ) {
        return this.$toasted.show("From Date is Greater Than TO Date");
      } else {
        let loader = this.$loading.show();
        let payload = {
        cinema_name:this.dropDown.selectedCinemaName,
        cinema_address:this.dropDown.selectedCinemaAddress,
          cinema_id: this.dropDown.selectedCinemaId,
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          isExcel: isExcelDownload === "Y" ? "Y" : "N",
          isPdf: isPdf === "Y" ? "Y" : "N",
        };

        // if (isExcelDownload == "Y") {
        //   payload["isExcel"] = "Y";
        // }
        // if (isPdf == "Y") {
        //   payload["isPdf"] = "Y";
        // }
        ReportsService.getMaskewaariReport(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.excelPath && isExcelDownload == "Y") {
              window.open(data.excelPath, "_blank");
            } else if (isPdf === "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            } else if (data.status) {
              this.MaskewaariRecords = [...data.Records];
              this.ProductInfoRecords = [...data.ProductSalesInfo];
            } else {
              this.$toasted.show(data.message);
            }
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      }
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}
.swc-report-table td {
  white-space: nowrap;
}
.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/MaskewaariReport.vue